export default "__VITE_ASSET__17336b1b__"